import React from 'react'
import {Col, Row, Panel, FormGroup, FormControl, Button} from 'react-bootstrap'

const UsersSearch = (props) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Panel className="user-filter">
      <Row>
        <Col md={12}>
          <FormGroup>
            <FormControl onChange={props.onInputChange}
                         onKeyPress={doSearch}
                         placeholder="Search by user id, first name, last name, username..."
                         value={props.searchValue}/>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup>
            <FormControl onChange={props.onUserGroupFilterChange}
                         value={props.userGroupFilterValue}
                         componentClass="select">
              <option value="">[Usergroup]</option>
              {
                props.userGroups && props.userGroups.map(item => {
                  return (<option key={item.id} value={item.id}>{item.name}</option>)
                })
              }
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <FormControl value={props.statusFilterValue}
                         onChange={props.onStatusFilterChange}
                         componentClass="select">
              <option value="">[Status]</option>
              {
                props.statuses && Object.keys(props.statuses).map(key => {
                  return (<option key={key} value={key}>{props.statuses[key]}</option>)
                })
              }
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={4} className="actions">
          <Button className="red-ghost-btn"
                  onClick={props.onSearch}>Search</Button>

          <Button className="red-ghost-btn"
                  onClick={props.onClear}>Clear search</Button>
        </Col>
      </Row>
    </Panel>
  );
};

export default UsersSearch;


// WEBPACK FOOTER //
// ./src/components/admin/users/list/users-search.jsx